
export const CLIENT_PERSONALITY_TYPE = [
  {
    id: 1,
    key: 'Red'
  },
  {
    id: 2,
    key: 'Yellow'
  },
  {
    id: 3,
    key: 'Green'
  }
]



// WEBPACK FOOTER //
// ./src/constants/clientPersonalityType.js